try {
	window.$ = window.jQuery = require('jquery');
	require('vgformsender/dist/js/vgformsender.min');
	require('vgscrollto/dist/js/vegascrollto.min');
	require('popper.js/dist/popper.min');
	require('bootstrap/dist/js/bootstrap.min');
	require('jquery-nice-select/js/jquery.nice-select.min');
	require('@fancyapps/fancybox/dist/jquery.fancybox');
	require('inputmask/dist/jquery.inputmask');
	window.AOS = require('aos/dist/aos');
	window.VGNav = require('vgnav/dist/js/vgnav');
	require('jquery.scrollbar/jquery.scrollbar');
	require('vgloadmore/dist/jquery.vegas-loadMore');

	require('../../vendor/inputmask/jquery.inputmask');
	require('../../vendor/modules/bg');
	require('../../vendor/modules/carousel');
	require('../../vendor/modules/modal');
	require('./modules/vegas');
	require('./modules/ym');
	require('./functions');

// [[vegas]]
	require('./custom');
} catch (e) {
	console.error('Что то пошло не так')
}
